import { cn } from "@/lib/cn";

/**
 * Inline section header for in-pane / in-card content blocks.
 *
 * Distinct from `<PageHeader/>` (which paints the page-level H1 and
 * eyebrow) and from `<Panel/>` (which wraps an entire card with title +
 * action menu). Use `SectionHeader` when a card or split pane needs
 * multiple sub-sections that each need a small label + optional action.
 */
export function SectionHeader({
  title,
  hint,
  actions,
  className,
}: {
  title: React.ReactNode;
  hint?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center justify-between gap-3", className)}>
      <div className="min-w-0">
        <div className="text-[11.5px] uppercase tracking-wider text-fg-dim">{title}</div>
        {hint && <p className="text-[12px] text-fg-muted mt-1 leading-relaxed">{hint}</p>}
      </div>
      {actions && <div className="flex items-center gap-1.5 shrink-0">{actions}</div>}
    </div>
  );
}
